export default {
    tooltip: {
        fontSize: '1em',
    },
};
